import { actionClickSrc180Evid9 } from '@wix/bi-logger-agent-maker-data/v2';
import { useContext } from 'react';
import { BiLoggerContext } from '../contexts';
export function useBi() {
  const {
    biLogger
  } = useContext(BiLoggerContext);
  const biClick = async _ref => {
    let {
      origin,
      value,
      entityType,
      entityId
    } = _ref;
    await biLogger.report(actionClickSrc180Evid9({
      value,
      origin,
      source_page: 'run_task_widget',
      entity_type: entityType,
      entity_id: entityId
    }));
  };
  return {
    biClick
  };
}
//# sourceMappingURL=useBi.js.map